import { Radio, TableCell, TableRow } from '@ksyos/design-system';
import type { IOrganization } from '../interfaces/organization';
import type { IPractitioner } from '../interfaces/practitioner';
import type { CareProviderOrganizationsPractitioners, InitialOrganizationPractitioner } from './CareProviderSelection';
import { FullName } from './common';

interface IGeneralPractitionerSearchTableBodyProps {
    initialOrganizationId: string | null;
    initialOrganizationPractitioner?: InitialOrganizationPractitioner;
    initialPractitionerId: string | null;
    onChange?: (value: string) => Promise<void>;
    organizationPractitioners?: CareProviderOrganizationsPractitioners[];
}

export function GeneralPractitionerSearchTableBody(props: IGeneralPractitionerSearchTableBodyProps) {
    if (props.organizationPractitioners) {
        return (
            <>
                {props.organizationPractitioners.map((organization) =>
                    organization.practitioners.map((practitioner) =>
                        renderTableBody(
                            practitioner,
                            organization,
                            props.initialPractitionerId,
                            props.initialOrganizationId
                        )
                    )
                )}
            </>
        );
    }
    if (props.initialOrganizationPractitioner) {
        return renderTableBody(
            props.initialOrganizationPractitioner.practitioner,
            props.initialOrganizationPractitioner,
            props.initialOrganizationPractitioner.practitioner.id,
            props.initialOrganizationPractitioner.id
        );
    }

    return null;

    function renderTableBody(
        practitioner: IPractitioner,
        organization: IOrganization,
        onValuePractitionerId: string | null,
        onValueOrganizationId?: string | null
    ) {
        return (
            <TableRow
                key={organization.id + '_' + practitioner.id}
                onClick={handleChange}
            >
                <TableCell>
                    <Radio
                        checked={practitioner.id === onValuePractitionerId && organization.id === onValueOrganizationId}
                        label={<FullName {...practitioner} />}
                        readOnly={true}
                    />
                </TableCell>
                <TableCell>{organization.name}</TableCell>
                <TableCell>{organization.city}</TableCell>
            </TableRow>
        );

        async function handleChange() {
            await props.onChange?.(organization.id + '_' + practitioner.id);
        }
    }
}
